import React, {JSX} from "react";
import {useTranslation} from "react-i18next";

interface SettingsProps {
    theme: string;
    setTheme: (value: string) => void;
}

function Settings({theme, setTheme}: SettingsProps): JSX.Element {
    const {t, i18n} = useTranslation();

    const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(event.target.value);
    };

    const handleThemeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        setTheme(value);
    };

    return (
        <div>
            <div>
                <h2>{t("menu.settings")}</h2>
            </div>

            <form className="form-container">
                <div className="form-row split-50-50">
                    <label>{t("settings.language.label")}</label>
                    <select value={i18n.language} onChange={handleLanguageChange}>
                        <option value="de">{t("settings.language.german")}</option>
                        <option value="en">{t("settings.language.english")}</option>
                        <option value="fr">{t("settings.language.french")}</option>
                        <option value="nl">{t("settings.language.netherlands")}</option>
                        <option value="it">{t("settings.language.italian")}</option>
                    </select>
                </div>

                <div className="form-row split-50-50">
                    <label>{t("settings.theme.label")}</label>
                    <select value={theme} onChange={handleThemeChange}>
                        <option value="light">{t("settings.theme.light")}</option>
                        <option value="dark">{t("settings.theme.dark")}</option>
                        <option value="system">{t("settings.theme.system")}</option>
                    </select>
                </div>
            </form>
        </div>
    );
}

export default Settings;